import { coreCapabilitiesSupportedBrowsers } from './coreCapabilitiesSupportedBrowsers';

export const coreBrowserNotSupported = () =>
	!coreCapabilitiesSupportedBrowsers.test(navigator.userAgent);
